<div
  class="category"
  (click)="searchByCategory($event, category.category_id)"
  [title]="('open' | t) + ' ' + category.category_title"
>
  <div class="category__title d-flex p-3">
    <div class="ml-2 pl-1 category__content-wrapper">
      <div class="d-flex category__title-wrapper">
        <h4 class="category__title-text text-big">
          {{ category.category_title }}
        </h4>
        <div class="category__follow ml-3">
          <app-follow-checkbox
            [entityName]="category.category_title"
            (click)="$event.stopPropagation()"
            [fc]="followControl"
          ></app-follow-checkbox>
        </div>
      </div>
      <p class="category__subtext">
        {{
          category.subcategories?.length > 0
            ? category.subcategories?.length + " disciplines • "
            : ""
        }}
        {{ category.event_count || 0 }} events
      </p>
      <div class="category__badge-wrapper">
        <div
          class="pt-1 pb-1 pr-1 mr-2 category__badge"
          *ngIf="category.subcategories?.length > 0"
        >
          <app-category-badge
            color="neutral"
            (click)="openSubcategory($event, category.category_id)"
          >
            Show Disciplines
          </app-category-badge>
        </div>
        <div class="pt-1 pb-1 pr-1 mr-2 category__badge">
          <app-category-badge
            color="transparent"
            (click)="searchByCategory($event, category.category_id)"
          >
            Show events
          </app-category-badge>
        </div>
      </div>
    </div>
  </div>
  <div class="category__background" [ngStyle]="dynamicStyles">
    <div class="category__background-mask"></div>
  </div>
</div>

<ng-template #unauthorizedUserPopup>
  <app-unauthorized-user-popup
    [title]="'general_unauthorized_text' | t"
    [helpText]="'general_unauthorized_help_text' | t"
  ></app-unauthorized-user-popup>
</ng-template>
